import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowLeftLong = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" })
});
export default SvgArrowLeftLong;
